import { Serializable } from '../../core/models/serializable';
export class MenuItemModel implements Serializable<MenuItemModel> {
  toObject() {
    throw new Error('Method not implemented.');
  }

  fromObject(obj: any) {
    this.displayName = obj.displayName;
    this.routePath = obj.routePath;
    return this;
  }

  public displayName: string;
  public routePath: string;
}
